( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '#start-form-btn' ).on( 'click', function() {
        $( 'body' ).addClass( 'mpf__show-form' );
      } );

      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( 'body' ).addClass( 'mpf__is-confirmation' );
        $( '.gform_confirmation_message' ).addClass( 'wysiwyg theme-one' );
      } );

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const $form = $( '#gform_' + formId );
        const $pages = $form.find( '.gform_page' );
        const $currentPage = $pages.eq( currentPage - 1 );

        if ( $currentPage.hasClass( 'submit-page' ) ) {
          $( 'body' ).addClass( 'mpf__is-submit-page' );
        } else {
          $( 'body' ).removeClass( 'mpf__is-submit-page' );
        }

        if ( $currentPage.hasClass( 'custom-submit' ) ) {
          const label = $form.find( 'input.gform_hidden' ).val();
          const $submitButton = $currentPage.find( 'button[type="submit"], input[type="submit"]' );

          if ( label && $submitButton.length ) {
            $submitButton.each( function() {
              if ( this.tagName.toLowerCase() === 'button' ) {
                $( this ).text( label );
              } else if ( this.tagName.toLowerCase() === 'input' ) {
                $( this ).val( label );
              }
            } );
          }
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
